
    import { mapState, mapActions, mapMutations } from 'vuex';

    export default {
        data() {
            return {
            };
        },

        computed: {
            ...mapState({
                $_emailDebounce: state => state.auth.emailDebounce,
            }),

            isEmailSuggested() {
                return this.$_emailDebounce.is_invalid && this.$_emailDebounce.did_you_mean;
            },

            isEmailInvalid() {
                return this.$_emailDebounce.is_validated && this.$_emailDebounce.is_invalid;
            },

            isEmailValid() {
                return this.$_emailDebounce.is_validated && !this.$_emailDebounce.is_invalid;
            },

            isEmailForced() {
                return this.$_emailDebounce.is_forced;
            },

            isEmailValidated() {
                return this.$_emailDebounce.is_validated;
            },

            showWelcomeMessage() {
                if (this.isEmailForced) {
                    return true;
                }
                if (!this.isEmailValidated) {
                    return false;
                }
                return !this.isEmailSuggested || !this.isEmailInvalid;
            },
        },

        methods: {
            ...mapActions('auth', {
                $_debounceValidateEmail: 'debounceValidateEmail',
            }),

            ...mapMutations('auth', {
                $_SET_EMAIL_VALIDATING: 'SET_EMAIL_VALIDATING',
                $_SET_EMAIL_DEBOUNCE: 'SET_EMAIL_DEBOUNCE',
                $_RESET_EMAIL_DEBOUNCE: 'RESET_EMAIL_DEBOUNCE',
            }),

            async debounceValidateEmail(userEmail) {
                this.$_SET_EMAIL_VALIDATING(true);
                const data = {
                    email: userEmail,
                };
                await this.$_debounceValidateEmail(data).then((response) => {
                    this.$_SET_EMAIL_DEBOUNCE({
                        key: 'is_validated',
                        value: true,
                    });
                    this.$_SET_EMAIL_DEBOUNCE({
                        key: 'is_invalid',
                        value: response.debounce.send_transactional !== '1',
                    });
                    this.$_SET_EMAIL_DEBOUNCE({
                        key: 'send_transactional',
                        value: response.debounce.send_transactional === '1',
                    });
                    this.$_SET_EMAIL_DEBOUNCE({
                        key: 'did_you_mean',
                        value: response.debounce.did_you_mean,
                    });
                }).finally(() => {
                    this.$_SET_EMAIL_VALIDATING(false);
                    this.$emit('debounceValidate');
                });
            },

            resetDebounceValidation() {
                this.$_RESET_EMAIL_DEBOUNCE();
            },

            onUserInput() {
                this.resetDebounceValidation();
            },
        },
    };
